<!-- App.vue -->

<script setup>
import { ref, onMounted } from 'vue'
import { RouterView } from 'vue-router'
import { useThemeStore } from '@/stores/theme'

// Inizializzalo una sola volta qui fuori
const themeStore = useThemeStore()
const deferredPrompt = ref(null)
const showInstallButton = ref(false)

onMounted(() => {

  window.addEventListener('beforeinstallprompt', (e) => {

    e.preventDefault()
    deferredPrompt.value = e
    showInstallButton.value = true
  })

  if (themeStore && typeof themeStore.initTheme === 'function') {

    themeStore.initTheme()
  } 
  else {

    console.error("Errore: themeStore non è caricato o manca initTheme")
  }
})

const installApp = async () => {

  if (!deferredPrompt.value) return

  deferredPrompt.value.prompt()
  const { outcome } = await deferredPrompt.value.userChoice;

  if (outcome === 'accepted') {

    console.log('User accepted the install prompt')
  }

  deferredPrompt.value = null
  showInstallButton.value = false
}
</script>

<template>
  <!-- Il wrapper per le transizioni fluide tra i temi -->
  <div v-if="showInstallButton" class="install-banner">
    <button @click="installApp">Installa Luna sul tuo dispositivo</button>
  </div>
  <div class="min-h-screen transition-colors duration-300">  
    <RouterView />
  </div>
</template>

<style>
body {
  margin: 0;
  padding: 0;
}
</style>